
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/programmes/jwc",
      function () {
        return require("private-next-pages/loyalty/programmes/jwc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/programmes/jwc"])
      });
    }
  